import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AlertService } from '../_services';
import { catchError, first, map, switchMap, take, tap } from 'rxjs/operators';
import { RestService } from '../_services/rest.service';
import { Trade } from '../_models/trade';
import { FunctionsService } from '../_services/functions.service';
import { ContractorTrade } from '../_models/contractor-trade';
import { BehaviorSubject, Observable, firstValueFrom, forkJoin, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { Contractor } from '@app/_models/contractor';
import { MsalService } from '@azure/msal-angular';
import { DatePipe } from '@angular/common';
import { Insurer } from '@app/_models/insurer';
import * as moment from 'moment';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { ActivatedRoute, Router } from '@angular/router';
import { Note } from '@app/_models/note';
import { Email } from '@app/_models/email';
import { TncAgreement } from '@app/_models/tncAgreement';
import { v4 as uuidv4 } from 'uuid';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { PrimeContact, PrimeContactAttributes, PrimeSubcontractorDetails } from '@app/_models/primeSubcontractor';
import { PrimeAccessToken } from '@app/_models/prime-access-token';

@Component({
  selector: 'app-add-edit-contractor',
  templateUrl: './add-edit-contractor.component.html',
  styleUrls: ['./add-edit-contractor.component.scss'],
})
export class AddEditContractorComponent implements OnInit {
  form!: FormGroup;
  isLoading = true;
  contractorId = 0;
  statusId = 0;
  isAddMode!: boolean;
  loading = false;
  submitted = false;
  selectedTabIndex = 0;
  isTncSigned = false;
  date: Date = new Date();
  trades: Array<Trade> = [];
  tradesData!: Trade[];
  tradeIdsArray: number[] = [];
  tradesList!: Trade[];
  tradesCheckedList: number[] = [];
  selected = new FormControl(0);
  active = 0;
  contractor = <any>{};
  originalTradingName: string = '';
  states!: Observable<any>;
  geoRegions!: Observable<any>;
  entityTypes!: Observable<any>;
  statuses!: Observable<any>;
  tradeCategories!: Observable<any>;
  insurers!: Observable<any>;
  licenceClassifications!: Observable<any>;
  tradeClassifications!: Observable<any>;
  swmsReceivedDateChangedByUser: boolean = false;
  swmsReceivedNote: string = '';
  swmsReceivedDate: Date | null = null;
  today = new Date();
  isPrime: boolean = false;
  primeContactAttributes = <PrimeContactAttributes>{};

  constructionInduction = [
    { id: 0, text: 'Not required' },
    { id: 1, text: 'Yes - Provided' },
    { id: 2, text: 'No - Not provided' },
  ];

  licenceRequired = [
    { id: true, text: 'Yes' },
    { id: false, text: 'No' },
  ];
  swmsRequired = [
    { id: true, text: 'Yes' },
    { id: false, text: 'No' },
  ];
  multiStateTrade = [
    { id: true, text: 'Yes' },
    { id: false, text: 'No' },
  ];
  isAHMakesafe = [
    { id: true, text: 'Yes' },
    { id: false, text: 'No' },
  ];

  contractorNames: string[] = [];
  userFullName = this.msalService.instance.getActiveAccount()!.name!;

  // =========================== Prime Subcontractor Update related =======================================
  primeSubcontractorUpdateUiMessage: string = '';
  primeSubcontractorUpdateIsError: boolean = false;
  primeSubcontractorUpdateIsSubmitting: boolean = false;
  // ======================================================================================================

  @ViewChild('autosize') autosize!: CdkTextareaAutosize;

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable
      .pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  onTabChange(e: any) {
  }

  onTabClick(event: any) {
  }

  onSelectedIndexChange(index: number): void {
    this.alertService.clear();
    this.selectedTabIndex = index;
    if (index == 2) {
      document.getElementById('tradeCheckboxes')?.focus();
    }
  }

  options$!: Observable<Insurer[]>;
  filteredOptions$!: Observable<Insurer[]>;
  private filteredOptionsSubject = new BehaviorSubject<Insurer[]>([]);

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    public restService: RestService,
    private msalService: MsalService,
    public functionsService: FunctionsService,
    private datePipe: DatePipe,
    private host: ElementRef,
    private _ngZone: NgZone,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.datePipe = new DatePipe('en-AU', 'Australia/Sydney');
    this.alertService.clear();
    this.contractorId = this.route.snapshot.params['contractorId'];
    this.isAddMode = !this.contractorId;
    const emailRegex = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$';
    const abnRegex = /^(?:\d{2} \d{3} \d{3} \d{3}|)$/;
    const acnRegex = /^(?:\d{3} \d{3} \d{3}|)$/;
    this.geoRegions = this.restService.getGeoRegions();
    this.states = this.restService.getStates();
    this.entityTypes = this.restService.getEntityTypes();
    this.statuses = this.restService.getStatusTypes();
    this.tradeCategories = this.restService.getTrades();
    this.insurers = this.restService.getInsurers();
    this.licenceClassifications = this.restService.getLicenceClassifications();
    this.tradeClassifications = this.restService.getTradeClassifications(
      this.contractorId
    );

    this.filteredOptions$ = this.filteredOptionsSubject.asObservable();
    this.options$ = this.restService.getInsurers().pipe(
      tap((o) => {
        this.filteredOptionsSubject.next(o);
      })
    );

    //const formOptions: AbstractControlOptions = {};
    this.form = this.formBuilder.group({
      mainGroup: this.formBuilder.group({
        contractorId: this.contractorId,
        tradingName: [
          '',
          [Validators.required, this.duplicateValidator.bind(this)],
        ],
        originalTradingName: [''],
        companyName: [''],
        mainTradeCategoryId: [null],
        entityTypeId: [null],
        statusId: [null],
        //abn: ['', [abnFormatValidator()]], // Apply the async validator],
        //abn: ['', [Validators.required, Validators.pattern(abnRegex)]],
        //abn: ['', [this.abnValidator(), Validators.pattern('^(\d *?){11}$')]],
        abn: ['', [this.abnValidator(), Validators.pattern(abnRegex)]],
        //acn: [''],
        acn: ['', [this.acnValidator(), Validators.pattern(acnRegex)]],
        //dateLastUsed: [{value:null, disabled: true}],
        //dateLastUsed: [{value: this.isAddMode ? null : this.contractor.dateLastUsed, disabled: true}],
        dateLastUsed: [{ disabled: true }],
        dateEvaluated: [null],
        compliancyNotes: [''],
        tradeServices: [''],
        licenceRequired: [null],
        addedBy: [null],
        addedOn: [null],
        lastModifiedBy: [null],
        lastModifiedOn: [null],
        swmsRequired: [null],
        multiStateTrade: [false],
        isAHMakesafe: [false],
        ahContactDetails: [''],
        primeSubcontractorID: [null],
      }),
      contactGroup: this.formBuilder.group({
        contactId: [''],
        contractorId: [''],
        mainContactName: [''],
        mainContactPhone: [''],
        mainContactEmail: ['', Validators.pattern(emailRegex)],
        accountContactName: [''],
        accountContactPhone: [''],
        accountContactEmail: ['', Validators.pattern(emailRegex)],
        address: [''],
        suburb: [''],
        postCode: [''],
        stateId: [null, Validators.required],
        geoRegionId: [null],
      }),
      insuranceGroup: this.formBuilder.group({
        insuranceId: [''],
        contractorId: [''],
        policyNumber: [''],
        policyExpiryDate: [null],
        policySumInsured: [null],
        plInsurer: [''],
        plinsurerId: [null],
        plpolicyNumber: [''],
        plexpiryDate: [null],
        plsumInsured: [null],
        wCorSickandAccInsurer: [''],
        wcsainsurerId: [null],
      }),
      licenceGroup: this.formBuilder.group({
        licencingId: [''],
        contractorId: [''],
        licenceName: [''],
        licenceClassification: [''],
        licenceConditions: [''],
        licenceClassificationId: [null],
        licenceNumber: [''],
        licenceExpiryDate: [null],
        licenceState: [null],
        licenceStatus: [''],
        constructionInduction: [null],
        swmsProvidedDate: [null],
      }),
    });

    if (!this.isAddMode) {
      if (this.contractorId) {
        this.isLoading = true;
        this.restService
          .getMainDetails(this.contractorId)
          .pipe(first())
          .subscribe((data) => {
            this.statusId = data.statusId;
            this.form.patchValue({
              mainGroup: {
                contractorId: data.contractorId,
                tradingName: data.tradingName?.replace(
                  /(?:\r\n|\r|\n)/g,
                  ' '
                ).trim(),
                originalTradingName: data.tradingName?.replace(
                  /(?:\r\n|\r|\n)/g,
                  ' '
                ).trim().toLowerCase(),
                companyName: data.companyName?.replace(
                  /(?:\r\n|\r|\n)/g,
                  ' '
                ).trim(),
                mainTradeCategoryId: data.mainTradeCategoryId,
                entityTypeId: data.entityTypeId,
                statusId: data.statusId,
                abn: data.abn?.replace(/^(\d{2})(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3 $4'),
                acn: data.acn?.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3'),
                dateLastUsed: data.dateLastUsed,
                dateEvaluated: data.dateEvaluated,
                compliancyNotes: data.compliancyNotes?.replace(
                  /(?:\r\n|\r|\n)/g,
                  ' '
                ).trim(),
                tradeServices: data.tradeServices,
                licenceRequired: data.licenceRequired,
                swmsRequired: data.swmsRequired,
                addedBy: data.addedBy,
                addedOn: data.addedOn,
                lastModifiedBy: data.lastModifiedBy,
                lastModifiedOn: data.lastModifiedOn,
                multiStateTrade: data.multiStateTrade,
                isAHMakesafe: data.isAHMakesafe,
                ahContactDetails: data.ahContactDetails,
                primeSubcontractorID: data.primeSubcontractorID
              },
            });

            this.isPrime = data.primeSubcontractorID != null;
            // // Check if the initial value is valid and set the control as pristine
            // // Use a setTimeout to mark the control as pristine after a small delay
            // setTimeout(() => {
            //   if (/^(\d{2} \d{3} \d{3} \d{3})$/.test(this.mainGroup.controls['abn'].value) || this.mainGroup.controls['abn'].value == '') {
            //     this.mainGroup.controls['abn'].markAsPristine();
            //   }
            // }, 0);
          }
          ),
          (error: any) => console.log(error);

        this.restService
          .getContactDetails(this.contractorId)
          .pipe(first())
          .subscribe((data) =>
            this.form.patchValue({
              contactGroup: {
                contactId: data.contactId,
                contractorId: data.contractorId,
                mainContactName: data.mainContactName?.replace(
                  /(?:\r\n|\r|\n)/g,
                  ' '
                ).trim(),
                mainContactPhone: data.mainContactPhone?.replace(/\s/g, ''),
                mainContactEmail: data.mainContactEmail?.toLowerCase(),
                accountContactName: data.accountContactName?.replace(
                  /(?:\r\n|\r|\n)/g,
                  ' '
                ).trim(),
                accountContactPhone: data.accountContactPhone?.replace(
                  /\s/g,
                  ''
                ),
                accountContactEmail: data.accountContactEmail?.toLowerCase(),
                address: data.address,
                suburb: data.suburb,
                postCode: data.postcode,
                stateId: data.stateId,
                geoRegionId: data.geoRegionId,
              },
            })
          ),
          (error: any) => console.log(error);

        this.restService
          .getInsuranceDetails(this.contractorId)
          .pipe(first())
          .subscribe((data) =>
            this.form.patchValue({
              insuranceGroup: {
                contractorId: data.contractorId,
                insuranceId: data.insuranceId,
                policyNumber: data.policyNumber,
                policyExpiryDate: data.policyExpiryDate,
                policySumInsured: data.policySumInsured,
                plinsurer: data.plinsurer,
                plinsurerId: data.plinsurerId,
                plpolicyNumber: data.plpolicyNumber,
                plexpiryDate: data.plexpiryDate,
                plsumInsured: data.plsumInsured,
                wcorSickandAccInsurer: data.wcorSickandAccInsurer,
                wcsainsurerId: data.wcsainsurerId,
              },
            })
          ),
          (error: any) => console.log(error);

        this.restService
          .getLicencingDetails(this.contractorId)
          .pipe(first())
          .subscribe((data) => {
            this.swmsReceivedDate = data.swmsProvidedDate;
            this.form.patchValue({
              licenceGroup: {
                contractorId: data.contractorId,
                licencingId: data.licencingId,
                licenceName: data.licenceName,
                licenceClassification: data.licenceClassification,
                licenceConditions: data.licenceConditions?.replace(
                  /(?:\r\n|\r|\n)/g,
                  ' '
                ).trim(),
                licenceClassificationId: data.licenceClassificationId,
                licenceNumber: data.licenceNumber,
                licenceExpiryDate: data.licenceExpiryDate,
                licenceState: data.stateId,
                licenceStatus: data.status,
                constructionInduction: data.constructionInduction,
                swmsProvidedDate: data.swmsProvidedDate,
                //swmsProvidedDate: this.datePipe.transform(data.swmsProvidedDate, 'yyyy-MM-dd')?.toString()
              },
            });
          }),
          (error: any) => console.log(error);
        this.getSelectedTrades(Number(this.contractorId));
      }
    } else {
      this.contractorId = 0;
      this.isPrime = true;
      this.form.patchValue({
        mainGroup: {
          dateLastUsed: null
        },
      });
      //dateLastUsed = null;
    }
    this.getAllTrades();

    this.restService.getContractors().subscribe({
      next: (data: Contractor[]) => {
        this.contractorNames = data.map((d) => d.tradingName?.trim().toLowerCase());
      },
      error: (err: Error) => {
        Swal.fire(
          'Error: restService.getContractors<br/>' + err,
          '',
          'error'
        );
        this.isLoading = false;
      },
    });
  }

  ngAfterViewInit() {
    this.host.nativeElement.focus();

    // Check if the initial value is valid and set the control as pristine
    // Use a setTimeout to mark the control as pristine after a small delay
    setTimeout(() => {
      if (/^(\d{2} \d{3} \d{3} \d{3})$/.test(this.mainGroup.controls['abn'].value) || this.mainGroup.controls['abn'].value == '') {
        this.mainGroup.controls['abn'].markAsPristine();
      }
    }, 0);
  }

  duplicateValidator(control: FormControl) {
    let contractor = control.value;
    if (
      contractor &&
      this.contractorNames.includes(contractor?.toLowerCase().trim()) &&
      this.mainGroup.controls['originalTradingName'].value.trim() !=
      contractor?.toLowerCase().trim()
    ) {
      return {
        duplicate: {
          contractor: contractor,
        },
      };
    } else {
      this.submitted = false;
    }
    return null;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  get mainGroup() {
    return this.form.controls.mainGroup as FormGroup;
  }

  get contactGroup() {
    return this.form.controls.contactGroup as FormGroup;
  }

  get licenceGroup() {
    return this.form.controls.licenceGroup as FormGroup;
  }

  //Get List of all available Trades
  getAllTrades() {
    this.alertService.clear();
    try {
      this.isLoading = true;
      this.restService.getTrades().subscribe(
        (data: Trade[]) => {
          let i = 1;
          data.forEach((element) => {
            element.id = i++;
          });
          this.trades = [];
          this.trades = data;
          this.tradeIdsArray = data.map((t) => t.id);
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
          this.alertService.error(error);
        }
      );
    } catch {
      this.isLoading = false;
    }
  }

  //Get List of selected Trades
  getSelectedTrades(contractorId: number) {
    try {
      this.restService.getSelectedTrades(contractorId).subscribe(
        (data: ContractorTrade[]) => {
          this.tradesCheckedList = [];
          this.tradesCheckedList = data.map((t) => t.tradeId);
        },
        (error) => {
          console.log(error);
          this.alertService.error(error);
        }
      );
    } catch {
      this.isLoading = false;
    }
  }

  addTradesForContractor(contractorId: number) {
    this.restService.addTrades(contractorId, this.tradesCheckedList);
  }

  async deleteTradesForContractor(contractorId: number) {
    return await this.restService.deleteTrades(contractorId);
  }

  get tradesFormArray() {
    return this.form.controls.trades as FormArray;
  }

  //Add trades to the checked list upon clicking on the checkbox
  setCheckedTradesList(list: number[]) {
    this.tradesCheckedList = list;
  }

  getCheckedTrades() {
    let trades = this.tradesCheckedList;
    return trades;
  }

  get() {
    var tradingName = this.form.get('tradingName')?.value.trim();
    if (typeof tradingName === 'string') {
      console.log(tradingName);
    }
  }

  onSubmit() {
    this.submitted = true;
    this.alertService.clear();

    if (this.form.invalid) {
      return;
    }

    try {
      this.loading = true;
      this.alertService.clear();
      if (this.isAddMode) {
        Swal.fire({
          title: 'Are you sure you want to add new Contractor to the Mk3 Contractors and Prime Subcontractors ?',
          icon: 'question',
          showDenyButton: true,
          confirmButtonText: 'Yes',
          denyButtonText: 'No',
          confirmButtonColor: '#007bff',
          denyButtonColor: '#dc3545',
          focusDeny: true,
          width: 450,
          padding: '1em',
          heightAuto: false,
        }).then(async (result) => {

          if (!result.isConfirmed) {
            this.submitted = false;
            this.loading = false;
            return;
          }

          try {

            this.primeSubcontractorUpdateUiMessage =
              'Creating contractor in local database...';

            //
            // 1. Create locally
            //
            const newContractorId = await this.addNewContractor();

            if (!newContractorId) {
              this.loading = false;

              Swal.fire(
                'Error',
                'Failed to create the contractor in the local database.',
                'error');

              return;
            }

            //
            // 2. Prime required?
            //
            if (this.selectedTabIndex == 0) {

              this.primeSubcontractorUpdateUiMessage =
                'Creating subcontractor in Prime external system...';

              this.restService.getContractorDetails(newContractorId).subscribe({

                next: (freshData: Contractor) => {
                  this.restService.createPrimeContact(freshData).subscribe({

                    next: (primeResponse) => {
                      this.loading = false;

                      Swal.fire(
                        'Success!',
                        'Contractor and Prime Subcontractor created successfully!',
                        'success'
                      ).then(() => {
                        this.router.navigate(['../contractor-details/' + newContractorId]);
                      });
                    },

                    error: (primeError) => {
                      this.loading = false;

                      console.error(
                        'Prime create failed',
                        primeError);

                      Swal.fire({

                        title:
                          'Mk3 Contractor Created, but <b>Prime</b> Creation Failed',

                        text:
                          'The contractor was created successfully in Mk3, however the subcontractor could not be created in Prime.',

                        icon: 'warning'

                      }).then(() => {
                          this.router.navigate(['../contractor-details/' + newContractorId]);
                      });
                    }
                  });
                },

                error: () => {
                  this.loading = false;

                  Swal.fire(
                    'Error',
                    'Could not retrieve the newly created contractor.',
                    'error');
                }
              });

            }
            else {
              this.loading = false;

              Swal.fire(
                'Success!',
                'Mk3 Contractor created successfully!</br>No Prime Subcontractor was created.',
                'success'
              ).then(() => {
                  this.router.navigate(['../contractor-details/' + newContractorId]);
              });
            }
          }
          catch (err) {
            this.loading = false;
            console.error(err);

            Swal.fire(
              'Error',
              'An unexpected error occurred while creating the contractor.',
              'error');
          }
        });

      } else {
        Swal.fire({
          title: 'Are you sure you want to update Contractor details?',
          icon: 'question',
          showDenyButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `No`,
          confirmButtonColor: '#007bff',
          denyButtonColor: '#dc3545',
          focusDeny: true,
          width: 450,
          padding: '1em',
          heightAuto: false,
        }).then(async (result) => {
          if (result.isConfirmed) {

            this.primeSubcontractorUpdateUiMessage = 'Updating local database records...';

            // 1. Await the completed local database update functions
            const localUpdateSuccess = await this.updateContractor(
              this.contractorId,
              (<FormGroup>this.form.controls['mainGroup']).value.tradingName,
              (<FormGroup>this.form.controls['contactGroup']).value.mainContactEmail
            );

            if (!localUpdateSuccess) {
              this.loading = false;
              Swal.fire('Error', 'Failed to update local contractor files. Prime sync skipped.', 'error');
              return;
            }

            if (this.selectedTabIndex == 0) {
              // Update both Mk3 Contractor and Prime Contractor
              // 2. Fetch the fresh database payload state
              this.primeSubcontractorUpdateUiMessage = 'Synchronising details with Prime external system...';
              this.restService.getContractorDetails(this.contractorId).subscribe({
                next: (freshData: Contractor) => {
                  this.contractor = { ...freshData };

                  // 3. Fire your API 2 update call (which now handles mapping internally via C#)
                  this.restService.updatePrimeContact(freshData).subscribe({
                    next: (primeResponse) => {
                      this.loading = false;

                      // 4. Alert user of absolute cross-system success
                      Swal.fire('Success!', 'Contractor details and Prime mapping updated successfully!', 'success').then(() => {
                        // 5. Navigate away only AFTER the user confirms the success alert
                        this.router.navigate(['../contractor-details/' + this.contractorId]);
                      });
                    },
                    error: (primeError) => {
                      this.loading = false;
                      console.error("Prime integration sync failed", primeError);

                      // Non-IT error translation mapping fallback display
                      let userFriendlyReason = primeError.error?.message || primeError.message || 'Unknown network rejection.';
                      Swal.fire({
                        title: 'Mk3 Contractor Save OK, but <b>Prime</b> Sync Failed</br>',
                        // text: `Mk3 Contractor details updated, but external <b>Prime</b> synchronisation failed.</br>Reason: ${userFriendlyReason}`,
                        text: `Mk3 Contractor details updated, but external <b>Prime</b> synchronisation failed.`,
                        icon: 'warning'
                      }).then(() => {
                        // Navigate anyway since local data saved, or remove this line to keep them on page
                        this.router.navigate(['../contractor-details/' + this.contractorId]);
                      });
                    }
                  });
                },
                error: (dbError) => {
                  this.loading = false;
                  Swal.fire('Error', 'Could not refresh contractor state from database.', 'error');
                }
              });
            }
            else {
              //Only update the Mk3 Contractor
              Swal.fire('Success!', 'Mk3 Contractor details has been updated successfully!</br>No changes made to the <b>Prime Subcontractor</b>', 'success').then(() => {
                // 5. Navigate away only AFTER the user confirms the success alert
                this.router.navigate(['../contractor-details/' + this.contractorId]);
              });
            }

          } else if (result.isDenied) {
            this.submitted = false;
            this.loading = false;
          }
        });
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }

  //Add new Contractor
  private async addNewContractor(): Promise<number | null> {
    let newContractorId = await this.addContractorMain();

    if (this.swmsReceivedDateChangedByUser)
      this.addSWMSReceivedNote(this.swmsReceivedNote);

    await this.addContacts(newContractorId);
    await this.addInsuranceDetails(newContractorId);
    await this.addLicenceDetails(newContractorId);
    await this.addTradesForContractor(this.contractorId);
    Swal.fire('Contractor added successfully!', '', 'success');
    this.alertService.success('Contractor added successfully!', {
      keepAfterRouteChange: true,
    });

    try {
      var email: Email;
      email = {
        from: 'trades@mk3.com.au',
        to: 'michael.doran@nibaustralia.com.au',
        cc: 'troy.mcfadden@mk3.com.au;',
        bcc: 'test@mk3.com.au',
        subject: 'New Contractor has been Added',
        body:
          'Added By: ' +
          this.userFullName +
          '<br/><br/>Please see the <a href=https://contractors.mk3apps.com.au/contractor-details/' +
          newContractorId +
          ' target="_blank">details here.</a><br/><br/>Please check all the compliance documents and approve the contractor.',
        attachmentName: null,
        attachmentContent: null,
        extraAttachmentName: null,
        extraAttachmentContent: null,
      };
      //this.restService.sendEmail(email).subscribe();
      this.restService.sendEmail(email, ('Email Type:Add or Edit Contractor' + ', User Name:' + this.userFullName + ', ContractorId:' + newContractorId.toString())).subscribe({
        next: () => { },
        error: (err: any) => {
          Swal.fire(
            'Error (Add new Contractor): restService.sendEmail: ' + err,
            '',
            'error'
          );
          console.log(
            'Error (Add new Contractor): restService.sendEmail: ' + err
          );
        },
      });
    } catch (error) {
      console.log(error);
    }

    //this.router.navigate(['../contractor-details/' + newContractorId]);

    if (!newContractorId) {
      return null;
    }
    return newContractorId;
  }

  /* updatePrimeSubcontractor(
   contractor: Contractor,
   body: any
 ): Observable<any> {
 
   return this.getAccessToken().pipe(
 
     switchMap((token: { access_token: any; }) => {
 
       const headers = new HttpHeaders({
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token.access_token}`
       });
 
       return this.http.patch(
         `${environment.primeContactsUrl}${contractor.primeSubcontractorID}`,
         body,
         { headers }
       );
 
     }),
 
     catchError(error => {
 
       this.alertService.clear();
 
       if (error.error instanceof ErrorEvent) {
         this.restService.errorMsg = `Error: ${error.error.message}`;
       } else {
         this.restService.errorMsg =
           this.restService.getServerErrorMessage(error);
       }
 
       this.alertService.error(this.restService.errorMsg);
 
       return throwError(() => this.restService.errorMsg);
     })
   );
 }*/

  /*updatePrimeSubcontractor(
    contractor: Contractor, body: string
  ): Observable<any> {
    try{
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http
      .patch(
        `${environment.primeApiUrl}` +
        this.contractor.primeSubcontractorID,
        { headers: headers, body: JSON.stringify(body) }
      )
      .pipe(map((x) => {
                return x;
              }),
              catchError((error) => {
                this.alertService.clear();
                if (error.error instanceof ErrorEvent) {
                  this.restService.errorMsg = `Error: ${error.error.message}`;
                } else {
                  this.restService.errorMsg = this.restService.getServerErrorMessage(error);
                  return throwError(this.restService.errorMsg);
                }
                this.alertService.error(this.restService.errorMsg);
                return throwError(this.restService.errorMsg);
              })
            );
             } catch (error: any) {
      console.log('Error: ' + error.message);
      this.alertService.error(error);
      return throwError(this.restService.errorMsg);
    }
  }*/

  //Update a Contractor
  private async updateContractor(id: number, name: string = '', mail: string = ''): Promise<boolean> {
    try {
      // 1. Await the note creation safely without triggering alerts/navigation early
      if (this.swmsReceivedDateChangedByUser) {
        const noteSaved = await this.addSWMSReceivedNote(this.swmsReceivedNote, false); // <-- FALSE stops internal redirects
        if (!noteSaved) {
          return false; // Stop the execution chain if saving the mandatory note fails
        }
      }

      // 2. Await remaining local components
      await this.updateContractorMain(id);
      await this.updateContacts(id);
      await this.updateInsuranceDetails(id);
      await this.updateLicenceDetails(id);
      await this.deleteTradesForContractor(this.contractorId);

      this.addTradesForContractor(this.contractorId);

      if ((<FormGroup>this.form.controls['mainGroup']).value.statusId !== this.statusId) {
        this.isTncSigned = await this.restService.getSignStatusByContractorID(this.contractorId);
        this.addStatusChangeNote(this.statusId, (<FormGroup>this.form.controls['mainGroup']).value.statusId);
      }

      if ((<FormGroup>this.form.controls['mainGroup']).value.statusId == 1 && this.statusId !== 1 && (<FormGroup>this.form.controls['contactGroup']).value.mainContactEmail !== '') {
        if (!this.isTncSigned) {
          this.sendTnC(name, mail);
        }
      }

      return true; // Mk3 Contractor processing succeeded completely
    } catch (error) {
      console.error("Mk3 Contractors database sync failure:", error);
      return false;
    }
  }

  updatePrimeSubcontractor(
    contractor: Contractor): void {
    this.primeSubcontractorUpdateIsSubmitting = true;
    this.primeSubcontractorUpdateUiMessage = 'Saving changes, please wait...';
    this.primeSubcontractorUpdateIsError = false;

    this.restService.updatePrimeContact(contractor).subscribe({
      next: (response) => {
        this.primeSubcontractorUpdateIsSubmitting = false;
        this.primeSubcontractorUpdateIsError = false;
        // Displays successful backend verification note
        this.primeSubcontractorUpdateUiMessage = response?.message || 'Changes saved successfully!';
      },
      error: (serverError) => {
        this.primeSubcontractorUpdateIsSubmitting = false;
        this.primeSubcontractorUpdateIsError = true;

        // Fallback friendly translation engine based on standard HTTP status codes
        if (serverError.status === 0) {
          this.primeSubcontractorUpdateUiMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
        } else if (serverError.status === 400) {
          this.primeSubcontractorUpdateUiMessage = 'The information provided seems incomplete or invalid. Please check the form data and re-submit.';
        } else if (serverError.status === 404) {
          this.primeSubcontractorUpdateUiMessage = 'The requested contractor profile could not be found in the system.';
        } else if (serverError.status === 500) {
          // If our .NET API returned a specific message string text, display it
          this.primeSubcontractorUpdateUiMessage = typeof serverError.error === 'string'
            ? serverError.error
            : (serverError.error?.message || 'The system encountered an error while saving. Please contact support if this persists.');
        } else {
          this.primeSubcontractorUpdateUiMessage = 'An unexpected issue occurred. Please refresh the page and try again.';
        }
      }
    });
  }

  addStatusChangeNote(oldStatus: number, newStatus: number) {
    let olds = '';
    let news = '';
    forkJoin([
      this.restService.getStatus(oldStatus),
      this.restService.getStatus(newStatus)
    ]).subscribe(([oldData, newData]) => {
      olds = oldData.status;
      news = newData.status;

      let newNote: Note = {
        contractorId: this.contractorId,
        noteTypeId: 6,
        refNo: null,
        addedBy: this.userFullName,
        comments: 'Updated Contractor status from ' + olds + ' to ' + news + ' when editing the Contractor' + (newStatus === 1 && !this.isTncSigned ? '. And the Terms & Conditions email has sent to the trade for signing.' : ''),
        timeStamp: new Date(moment.utc(moment.utc().format()).local().utcOffset(0, true).format()),
      };
      this.restService
        .addNewNote(newNote)
        .pipe(first())
        .subscribe({
          next: () => {
            return true;
          },
          error: (error) => {
            console.log(error);
            this.alertService.error(error);
            this.loading = false;
          },
        });
    });
  }

  async addContractorMain() {
    (<FormGroup>this.form.controls['mainGroup']).patchValue({
      addedBy: this.userFullName,
    });
    (<FormGroup>this.form.controls['mainGroup']).patchValue({
      addedOn: moment().format(),
    });
    return await this.restService.addContractorMain(
      (<FormGroup>this.form.controls['mainGroup']).value
    );
  }

  async addContacts(contractorId: number) {
    this.restService
      .addContacts(
        (<FormGroup>this.form.controls['contactGroup']).value,
        contractorId
      )
      .pipe(first())
      .subscribe({
        next: () => {
          return true;
        },
        error: (error) => {
          console.log(error);
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }

  async addInsuranceDetails(contractorId: number) {
    this.restService
      .addInsuranceDetails(
        (<FormGroup>this.form.controls['insuranceGroup']).value,
        contractorId
      )
      .pipe(first())
      .subscribe({
        next: () => {
          return true;
        },
        error: (error) => {
          console.log(error);
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }

  async addLicenceDetails(contractorId: number) {
    this.restService
      .addLicenceDetails(
        (<FormGroup>this.form.controls['licenceGroup']).value,
        contractorId
      )
      .pipe(first())
      .subscribe({
        next: () => {
          return true;
        },
        error: (error) => {
          console.log(error);
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }

  async updateContractorMain(id: number) {
    (<FormGroup>this.form.controls['mainGroup']).patchValue({
      lastModifiedBy: this.userFullName,
    });
    (<FormGroup>this.form.controls['mainGroup']).patchValue({
      lastModifiedOn: moment
        .utc(moment.utc().format())
        .local()
        .utcOffset(0, true)
        .format(),
    }); //Works but as UTC // "2021-12-16T00:20:51.579Z" //{16/12/2021 12:20:51 AM}

    this.restService
      .updateContractorMain(id, (<FormGroup>this.form.controls['mainGroup']).value)
      .pipe(first())
      .subscribe({
        next: () => {
          return true;
        },
        error: (error: string) => {
          console.log(error);
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }

  async sendTnC(name: string, mail: string) {
    let tnc = new TncAgreement();
    tnc.id = uuidv4();
    tnc.contractorId = this.contractorId;
    this.restService.getMaxVersionByContractorID(this.contractorId).subscribe({
      next: verNo => {
        tnc.documentTitle = 'Mk3 Terms & Conditions Agreement form v' + ((verNo !== undefined && verNo !== null) ? (verNo + 1).toString() : '1') + ' ' + (new Date()).getFullYear().toString();
        tnc.versionNo = (verNo !== undefined && verNo !== null) ? (verNo + 1) : 1;
        tnc.dateSent = new Date(moment.utc(moment.utc().format()).local().utcOffset(0, true).format());

        this.restService.addTncAgreement(tnc).subscribe((x: HttpResponse<any>) => {
          if (x.status == 201) {
            var email: Email;
            let url = 'https://sign.mk3.com.au/#/contractor-agreement/' + x.body.id.toString();
            let body = '<p>Hello ' + name + ' ,</p> <p>As part of improving relationships with our valued contractors and suppliers, we have been working on improving the way in which Mk3 Group communicates our expectations and requirements when you work with the Mk3 Group by creating a standard set of terms and conditions and a new work instruction sheet. The terms and conditions provide clear detail on how we will manage our commercial relationship with our contractors and suppliers. The new Work Instruction Sheet will provide greater detail in regard to the way you will work with us on each job. The Work Instruction Sheet will still cover off the same basic elements such as scope of work and client details, however it will have more detail in the areas of timing for the works and the way in which works will be invoiced to the Mk3 Group as outlined below.</p> <p>There are three categories when it comes to the invoicing of works:</p> <ul> <li><strong>Fixed Price or Lump Sum</strong> - This is when you have submitted a quotation for the works, it has been approved, and the Work Instruction Sheet will cover the scope and the relevant quoted price.</li> <li><strong>Schedule of Rates</strong> - This is when you have submitted a prescribed schedule of rates and you will be given an allowance to complete the supplied scope of works under the agreed/approved schedule of rates. In some instances, you may be given authority to complete works up to a specific value ($1500 ex GST) utilising the agreed rates. This does not mean the order or Work Instruction Sheet is for the value of $1500 ex GST, it means you have authority up to $1500 ex GST. If your works are expected to exceed the pre-authorised value, you are to contact the issuing assessor and notify them of the increase and seek approval from them in writing before proceeding. All payment claims will need to be evidenced with time and materials and photographs of your work.</li> <li><strong>Day Rate</strong> - Being the actual evidenced and reasonable cost of undertaking the works inclusive of margin. Again, in some instances, you may be given authority to complete works up to a specific value ($1500 ex GST) utilising the agreed rates. This does not mean the order or Work Instruction Sheet is for the value of $1500 ex GST, it means you have authority up to $1500 ex GST. If your works are expected to exceed the pre-authorised value, you are to contact the issuing assessor and notify them of the increase and seek approval from them in writing before proceeding. All payment claims will need to be evidenced with time and materials and photographs of your work.</li> </ul> <p>Works values over $50,000 will require contract works insurance.</p> <p>Works values over $100,000 will require Personal Guarantee and Contract works Insurance.</p> <p>Here is the link to the <a href="' + url + '">Mk3 Group Contractor Terms and Conditions</a>.</p> <p>If you could take the time to review both documents and sign the Contractor Terms and Conditions and please feel free to contact the compliance team should you have any further questions.</p> <p>Thank You,</p> <p>Regards,</p> <p>Mk3 Group Pty Ltd</p>';
            email = {
              from: 'trades@mk3.com.au',
              to: mail,
              cc: null,//'michael.doran@nibaustralia.com.au',
              bcc: null,//'test@mk3.com.au;troy.mcfadden@mk3.com.au;',
              subject: 'Mk3 Group Terms and Conditions (Required Signing)',
              body: body,
              attachmentName: null,
              attachmentContent: null,
              extraAttachmentName: null,
              extraAttachmentContent: null,
            };
            this.restService.sendEmail(email).subscribe(
              (response: any) => {
                if (response.status == 200) {
                  Swal.fire(
                    'Contractor details updated successfully! and Send Contractor T&C Agreement successfully!\r\nEmail has been sent to the Contractor',
                    '',
                    'success'
                  );
                }
                else {
                  Swal.fire(
                    'Contractor details updated successfully! But Send Contractor T&C Agreement failed!\r\nEmail has not sent to the Contractor, please contact the IT Department with details',
                    '',
                    'error'
                  );
                }
              },
              (err: any) => {
                Swal.fire(
                  'Contractor details updated successfully! But Error occured when sending Contractor Send T&C Agreement Email: ' + err.message + 'Please contact the IT Department with details',
                  '',
                  'error'
                );
              },
            );
          }
          else {
            Swal.fire(
              'Contractor details updated successfully! But Add T&C Agreement record failed!\r\nPlease contact the IT Department with details',
              '',
              'error'
            );
          }
        },
          (err: any) => {
            Swal.fire(
              'Contractor details updated successfully! But Error occured when adding Contractor T&C Agreement record: ' + err.message + 'Please contact the IT Department with details',
              '',
              'error'
            );
          },
        );
      }
    });
  }

  async updateContacts(id: number) {
    this.restService
      .updateContacts(id, (<FormGroup>this.form.controls['contactGroup']).value)
      .pipe(first())
      .subscribe({
        next: () => {
          return true;
        },
        error: (error) => {
          console.log(error);
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }

  async updateInsuranceDetails(id: number) {
    this.restService
      .updateInsuranceDetails(
        id,
        (<FormGroup>this.form.controls['insuranceGroup']).value
      )
      .pipe(first())
      .subscribe({
        next: () => {
          return true;
        },
        error: (error) => {
          console.log(error);
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }

  async updateLicenceDetails(id: number) {
    this.restService
      .updateLicenceDetails(
        id,
        (<FormGroup>this.form.controls['licenceGroup']).value
      )
      .pipe(first())
      .subscribe({
        next: () => {
          return true;
        },
        error: (error) => {
          console.log(error);
          this.alertService.error(error);
          this.loading = false;
        },
      });
  }

  onAutocompleteKeyUp(searchText: string, options: Insurer[]): void {
    const lowerSearchText = searchText?.toLowerCase();
    this.filteredOptionsSubject.next(
      !lowerSearchText
        ? options
        : options.filter((r) =>
          r.insurer.toLocaleLowerCase().includes(lowerSearchText)
        )
    );
  }

  getAutoCompleteDisplayValue(option: Insurer): string {
    return option ? option.insurer : '';
  }

  onSWMSProvidedDateChange() {
    //let previousDate = this.licenceGroup.get('swmsProvidedDate')?.value;
    //this.swmsReceivedDate
    let title = 'SWMS received date changed';
    Swal.fire({
      title: title,
      text: 'Please add a note related to this change of the SWMS Received Date',
      input: 'text',
      inputPlaceholder: 'Please enter the note here',
      icon: 'info',
      confirmButtonText: `Add Note`,
      confirmButtonColor: '#007bff',
      denyButtonColor: '#dc3545',
      focusDeny: true,
      width: 700,
      padding: '1em',
      heightAuto: false,
      inputValidator: (value) => {
        if (!value) {
          return 'You need to write something!';
        } else if (value.length > 255) {
          return 'Note too Long!. Should be less than 255 characters';
        } else {
          return '';
        }
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.swmsReceivedDateChangedByUser = true;
        this.swmsReceivedNote = result.value;
        this.swmsReceivedDate =
          this.licenceGroup.get('swmsProvidedDate')?.value;
      } else
        this.form.controls['licenceGroup'].patchValue({
          swmsProvidedDate: this.swmsReceivedDate,
        });
    });
  }

  async addSWMSReceivedNote(note: string, shouldNavigate: boolean = true): Promise<boolean> {
    try {
      const userFullName = this.msalService.instance.getActiveAccount()!.name!;
      let newNote: Note = {
        contractorId: this.contractorId,
        noteTypeId: 1,
        refNo: null,
        addedBy: userFullName,
        comments: note,
        timeStamp: null,
      };

      this.loading = true;

      // Convert the Observable sequence directly into an awaitable Promise
      await firstValueFrom(this.restService.addNewNote(newNote).pipe(first()));

      // ONLY pop up and route away if this function was called as a standalone action
      if (shouldNavigate) {
        this.loading = false;
        await Swal.fire('SWMS received note has been added successfully!', '', 'success');
        await this.router.navigate(['../contractor-details/' + this.contractorId]);
      }

      return true; // Note saved cleanly
    } catch (error) {
      this.loading = false;
      console.error("Failed to add SWMS Note:", error);
      this.alertService.error(typeof error === 'string' ? error : 'Failed to save SWMS note.');
      return false; // Saving failed
    }
  }

  abnValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
      const cleanedABN = control.value.replace(/\D/g, '');

      let valid = false;

      if (cleanedABN.length === 11) {
        let sum = 0;
        weights.forEach((weight, ind) => {
          const digit = parseInt(cleanedABN[ind], 10) - (ind === 0 ? 1 : 0);
          sum += weight * digit;
        });
        valid = sum % 89 === 0;
      } else {
        if (cleanedABN == '' || cleanedABN == undefined)
          valid = true;
        else
          valid = false;
      }
      return valid ? null : { invalid: true };
    };
  }

  acnValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let valid = false;
      const cleanedACN = control.value?.replace(/\D/g, '');

      if (cleanedACN == '' || cleanedACN == undefined)
        valid = true;

      if (cleanedACN?.length == 9 && !isNaN(parseInt(cleanedACN))) {
        const weighting = [8, 7, 6, 5, 4, 3, 2, 1];
        let weighted = 0;
        for (let i = 0; i < weighting.length; i++) {
          weighted += parseInt(cleanedACN.charAt(i)) * weighting[i];
        }
        let checkDigit = 10 - (weighted % 10);
        checkDigit = checkDigit == 10 ? 0 : checkDigit;
        valid = checkDigit == Number(cleanedACN[8]);
      }
      return valid ? null : { invalid: true };
    };
  }
  // public hasError = (controlName: string, errorName: string) => {
  //   return this.form.controls[controlName].hasError(errorName);
  // };
}
